import React, { useState } from "react";
import { Row, Form, Col, Input, Checkbox, Button, Divider, Anchor } from "antd";
import { useLoginForm } from "../../../../hooks/useLoginForm";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import actions from "../../../../redux/actions/userAction";

interface IProps {
  screen: string | undefined;
  id: string | undefined;
}

export const FormLogin: React.FC<IProps> = (props: IProps) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();

  const { onFinish, errormsj, setErrorMsj, mensajeError } = useLoginForm();
  const [errorMessage, setErrorMessage] = useState(false);

  //TODO:  usar cuando este jwt
  const onLogin = async (values) => {
    const res: any = await dispatch(actions.login(values));

  };

  return (

    <div className="d-flex justify-content-center align-self-center">
      <Form layout="vertical" onFinish={(values: any) => /*onLogin(values)*/ onFinish(values, props.screen, props.id)}>
        <div className="row">
          <div className="col-12">
            <Form.Item
              label={
                <div className="row">
                  <div className="col-12 letter-spacing-0px font-size-12px font-family-Montserrat-Regular font-color-000000">
                    Número de identificación
                  </div>
                </div>
              }
              name="user"
              rules={[
                {
                  required: true,
                  message: "Este campo es requerido",
                },
              ]}
            >
              <Input type="number" size="large" />
            </Form.Item>
          </div>
          <div className="col-12">
            <Form.Item
              label={
                <div className="row">
                  <div className="col-12 no-margin letter-spacing-0px font-size-12px font-family-Montserrat-Regular font-color-000000">
                    Digita tu contraseña
                  </div>
                </div>
              }
              name="password"
              rules={[
                {
                  required: true,
                  message: "Este campo es requerido",
                },
              ]}
            >
              <Input.Password
                size="large"
                className="font-size-12px"
                iconRender={(visible) =>
                  visible ? (
                    <div className="row">
                      <div className="col-12 font-size-12px">VER</div>
                    </div>
                  ) : (
                    <div className="col-12">
                      <div className="font-size-12px">VER</div>
                    </div>
                  )
                }
              />
            </Form.Item>

          </div>
          {errormsj ? (
            <>
              <div className="" style={{ paddingLeft: '20px', paddingRight: '20px' }}>
                <div className="row container-error-login">
                  <div className="col-11 font-color-AD0808 font-size-12px font-family-Montserrat-Regular">{mensajeError}</div>
                  <div className="col-1 justify-content-flex-end font-size-12px font-color-AD0808" onClick={() => setErrorMsj(false)} style={{ cursor: 'pointer' }} >x</div>
                </div>
              </div>

              {/* <div className="row container-error-login">
                <div className="col-xl-8 col-10 font-color-AD0808 font-size-12px font-family-Montserrat-Regular">
                  {mensajeError}
                </div>
                <div className="col-4 col-lg-2 justify-content-flex-end">
                  <Button className="button-error-login" onClick={() => setErrorMsj(false)}>
                    <div>
                      <div className="font-size-12px font-color-AD0808">X</div>
                    </div>
                  </Button>
                </div>
              </div> */}
            </>
          ) : null}
          <div className="col-12">
            <Form.Item className="no-margin" name="recordar" valuePropName="checked">
              <Checkbox>
                <div className="row">
                  <div className="col-12 font-size-12px">Recordar datos de acceso</div>
                </div>
              </Checkbox>
            </Form.Item>
          </div>
          <div className="col-6">
            <Button className="button-blanco-radius font-size-11px" onClick={() => navigate("/usuario/registrarUsuario")}>Registrarse</Button>
          </div>
          <div className="col-6 justify-content-flex-end">
            <Button className="button-azul-radius font-size-11px" htmlType="submit">
              Ingresar
            </Button>
          </div>
          <Divider style={{ marginTop: "1%" }} />
          <div
            className="col-12 d-flex justify-content-md-center "
          >
            <div>
              <span className="font-family-Montserrat-Regular font-size-12px pe-2">¿Olvidaste tu contraseña?</span>  <a className="font-color-051923bf " onClick={() => window.location.href = "https://www.medellin.gov.co/"}>
                <span className="font-family-Montserrat-Regular font-size-12px">Recupérala AQUÍ</span>
              </a>
            </div>
          </div>

          <div
            className="col-12 d-flex justify-content-md-center mt-5"
          >
            <div>
              <span className="font-family-Montserrat-Regular font-size-10px">Powered by </span>
              <span className="font-family-Montserrat-Regular font-size-10px" style={{ opacity: '0.5' }}>Secretaría de innovación Digital</span>
            </div>
          </div>

        </div>
      </Form>
    </div>

  );
};
